import { JsonObject } from '../helpers';

export class NosqlDocModel {
  id: string;

  constructor(props: JsonObject = {}) {
    const data = props as Record<string, keyof NosqlDocModel>;

    this.id = (data._id as string) || (data.id as string) || '';
  }
}
